import secureLocalStorage from "react-secure-storage";
import Api from "../Services/Api";
import { toastr } from "react-redux-toastr";

//SuperAdmin
export const USERNAME = "riskwell/login/USERNAME";
export const PASSWORD = "riskwell/login/PASSWORD";
export const LOGINSUCCESS = "riskwell/login/LOGINSUCCESS";

//Tenant
export const TENANTKEY = "riskwell/login/TENANTKEY";
export const TENANTLOGINSTATUS = "riskwell/login/TENANTLOGINSTATUS";
export const TENANTLOGINFAILURE = "riskell/login/TENANTLOGINFAILURE";
export const USERLOGINSTATUS = "riskwell/login/USERLOGINSTATUS";
export const RESETPASSWORDLOGINSTATUS = "riskwell/login/RESETPASSWORDLOGINSTATUS";
export const LOGGEDINLOADER = "riskwell/login/LOGGEDINLOADER";

// Global auth context reference - will be set by the Login component
let authContext = null;

export const setAuthContext = (context) => {
  authContext = context;
};

//SuperAdmin
export const userName = (name) => {
  return {
    type: USERNAME,
    payload: name,
  };
};

export const passWord = (pwd) => {
  return {
    type: PASSWORD,
    payload: pwd,
  };
};

export const LoginSatus = (success) => {
  return {
    type: LOGINSUCCESS,
    payload: success,
  };
};

export const loggedInLoader = (bool) => {
  return {
    type: LOGGEDINLOADER,
    payload: bool,
  };
};

export const superAdminLogin = (params) => async (dispatch) => {
  try {
    dispatch(loggedInLoader(true));
    let result = await Api.userLogin(params);
    dispatch(loggedInLoader(false));
    if (result.status === 200 && result.message === "Success") {
      let token = "Bearer" + " " + result.token;
      
      // Store auth data in localStorage for backward compatibility
      secureLocalStorage.setItem("authToken", token);
      secureLocalStorage.setItem("loggedClient", "SuperAdmin"); // Changed to uppercase 'S' for consistency
      secureLocalStorage.setItem("userName", result.users[0].userName);
      
      // Update auth context if available
      if (authContext && authContext.login) {
        authContext.login({
          userName: result.users[0].userName,
          loggedClient: "SuperAdmin" // Changed to uppercase 'S' for consistency
        });
      }
      
      dispatch(LoginSatus(result.message));
    } else {
      toastr.error(result.message);
    }
  } catch (err) {
    toastr.error(err.message);
    dispatch(loggedInLoader(false));
  }
};

//Tenant

export const tenantKey = (key) => {
  return {
    type: TENANTKEY,
    payload: key,
  };
};

export const tenantLoginStatus = (bool) => {
  return {
    type: TENANTLOGINSTATUS,
    payload: bool,
  };
};
export const ResetPasswordLoginStatus = (bool) => {
  return {
    type: RESETPASSWORDLOGINSTATUS,
    payload: bool,
  };
};
export const tenantLoginFailure = (err) => {
  return {
    type: TENANTLOGINFAILURE,
    payload: err,
  };
};

export const userLoginStatus = (data) => {
  
  return {
    type: USERLOGINSTATUS,
    payload: data,
  };
};

export const TenantLogin = (params) => async (dispatch) => {
  try {
    dispatch(loggedInLoader(true));
    let result = await Api.tenantLogin(params);
    
    if (result.status === 200 && result.loggedClient === "Tenant") {
      dispatch(loggedInLoader(false));
      let token = "Bearer" + " " + result.token;
      
      // Store auth data in localStorage for backward compatibility
      secureLocalStorage.setItem("authToken", token);
      secureLocalStorage.setItem("tenantKey", result.tenant[0].tenantKey);
      secureLocalStorage.setItem("tenantId", result.tenant[0].tenantId);
      secureLocalStorage.setItem("loginUserId", result.tenant[0].tenantId);
      secureLocalStorage.setItem("setEmail", result.tenant[0].tenantEmail);
      secureLocalStorage.setItem("loggedClient", "tenant");
      secureLocalStorage.setItem("userName", result.tenant[0].tenantName);
      secureLocalStorage.setItem("role", result.tenant[0].role);
      secureLocalStorage.setItem("isTasksModuleEnabled", result.tenant[0].isTasksModuleEnabled);
      secureLocalStorage.setItem("isPrime", result.tenant[0].isPrimeSubsibed);
      
      // Update auth context if available
      if (authContext && authContext.login) {
        authContext.login({
          tenantKey: result.tenant[0].tenantKey,
          userName: result.tenant[0].tenantName,
          role: result.tenant[0].role,
          isPrimeSubsibed: result.tenant[0].isPrimeSubsibed,
          isTasksModuleEnabled: result.tenant[0].isTasksModuleEnabled,
          loggedClient: "tenant"
        });
      }
      
      try {
        let currency = JSON.parse(result.currencyTypes[0].currency);
        secureLocalStorage.setItem("currency", currency.symbol);
      } catch (err) {}
      
      if (result.isPasswordReset === true) {
        dispatch(ResetPasswordLoginStatus(result.message));
      } else {
        dispatch(tenantLoginStatus(result.message));
      }
    } else if (result.status === 200 && result.loggedClient === "User") {
      dispatch(loggedInLoader(false));
      let token = "Bearer" + " " + result.token;
      
      // Store auth data in localStorage for backward compatibility
      secureLocalStorage.setItem("authToken", token);
      secureLocalStorage.setItem("userKey", result.tenantKey);
      secureLocalStorage.setItem("userId", result.tenantUserResp[0].userId);
      secureLocalStorage.setItem("loginUserId", result.tenantUserResp[0].userId);
      secureLocalStorage.setItem("loggedClient", "user");
      secureLocalStorage.setItem("userName", result.tenantUserResp[0].name);
      secureLocalStorage.setItem("setEmail", result.tenantUserResp[0].emailAddress);
      secureLocalStorage.setItem("role", result.tenantUserResp[0].role);
      secureLocalStorage.setItem("isTasksModuleEnabled", result.tenantUserResp[0].isTasksModuleEnabled);
      secureLocalStorage.setItem("isPrime", result.tenantUserResp[0].isPrimeSubsibed);

      
      // Update auth context if available
      if (authContext && authContext.login) {
        authContext.login({
          userKey: result.tenantKey,
          userName: result.tenantUserResp[0].name,
          role: result.tenantUserResp[0].role,
          isPrimeSubsibed: result.tenantUserResp[0].isPrimeSubsibed,
          isTasksModuleEnabled: result.tenantUserResp[0].isTasksModuleEnabled,
          loggedClient: "user"
        });
      }
      
      try {
        let currency = JSON.parse(result.currencyTypes[0].currency);
        secureLocalStorage.setItem("currency", currency.symbol);
      } catch (err) {}
      
      if (result.isPasswordReset === true) {
        dispatch(ResetPasswordLoginStatus(result.message));
      } else {
        dispatch(userLoginStatus(result.message));
      }
    } else {
      dispatch(loggedInLoader(false));
      toastr.error(result.message);
      dispatch(tenantLoginFailure(result.message));
    }
  } catch (err) {
    dispatch(loggedInLoader(false));
    toastr.error("Invalid User");
    dispatch(tenantLoginFailure("Invalid User"));
  }
};
